function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20.9004,
  cy: 20.8591,
  r: 20.75,
  fill: "#F35376"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.9122 30.8202L20.9005 30.8206L20.9005 30.8204H20.8886C20.753 30.7242 19.0688 29.5229 17.1219 27.8608C15.1613 26.1869 12.9848 24.0875 11.8277 22.1989C11.8275 22.1986 11.8272 22.198 11.8267 22.1972L11.819 22.1842L11.819 22.1842C11.3301 21.3732 11.0713 20.4414 11.0713 19.4881C11.0713 16.6051 13.4176 14.2588 16.3006 14.2588C17.9701 14.2588 19.5202 15.0519 20.4989 16.3694L20.9003 16.9097L21.3017 16.3694C22.2804 15.0519 23.8307 14.2588 25.5 14.2588C28.3829 14.2588 30.7293 16.6051 30.7293 19.4881C30.7293 20.4414 30.4705 21.3732 29.9816 22.1842L29.9814 22.1841L29.9754 22.1948L29.974 22.1972C28.8173 24.0862 26.6401 26.1864 24.6788 27.8608C22.7321 29.5228 21.048 30.724 20.9122 30.8202Z",
  stroke: "white"
});

var SvgLife = function SvgLife(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLife, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/life.4fb5ea3d.svg";
export { ForwardRef as ReactComponent };